import React from 'react';
import PropTypes from 'prop-types';
import { FormFeedback } from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import get from 'lodash/get';

import { validationCheckErrorType } from 'constants/index';
import { checkHadError } from 'utils';
import cn from 'utils/classnames';
import { ReactComponent as ChevronDown } from 'assets/images/Chervon.svg';

import styles from './FlatPickInput.module.scss';

const AppFlatPickInput = (props) => {
  const {
    isShowError,

    checkErrorType,
    keyName,
    name,
    id,
    placeholder,
    value,
    className,

    options,
    validation,

    onChange,
  } = props;

  const keyCheckError = React.useMemo(() => (keyName || name), [keyName, name]);

  const isHadError = React.useMemo(() => checkHadError(
    validation, keyCheckError, checkErrorType,
  ), [validation, keyCheckError, checkErrorType]);

  const defaultOptions = React.useMemo(() => ({
    ...options,
    dateFormat: 'd/m/Y',
    locale: Vietnamese,
  }), [options]);

  const onChangeDate = React.useCallback((date) => {
    onChange(date, name, id);
  }, [name, id, onChange]);

  return (
    <>
      <div className={styles.Wrapper}>
        <Flatpickr
          name={name}
          placeholder={placeholder}
          onChange={onChangeDate}
          value={value || get(validation.values, keyCheckError, '')}
          options={defaultOptions}
          className={cn(styles.Flatpickr, className)}
        />
        <ChevronDown className={styles.ChevronIcon} />
      </div>

      {
        isShowError && isHadError && (
          <FormFeedback type="invalid" className="d-block">
            {get(validation.errors, keyCheckError, '')}
          </FormFeedback>
        )
      }
    </>
  );
};

AppFlatPickInput.propTypes = {
  isShowError: PropTypes.bool,

  checkErrorType: PropTypes.oneOf([
    '',
    validationCheckErrorType.ERR_ONLY,
    validationCheckErrorType.TOUCHED_ONLY,
  ]),
  id: PropTypes.string,
  keyName: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,

  placeholder: PropTypes.string,
  className: PropTypes.string,

  options: PropTypes.instanceOf(Object),
  validation: PropTypes.instanceOf(Object),

  onChange: PropTypes.func.isRequired,
};

AppFlatPickInput.defaultProps = {
  isShowError: true,

  id: '',
  checkErrorType: '',
  keyName: '',
  name: '',
  placeholder: 'Chọn',
  value: '',
  className: '',

  options: {},
  validation: {},
};

export default React.memo(AppFlatPickInput);
